"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assert = void 0;
var assert = {
  isRequired: function isRequired(obj, source) {
    var missingKeys = Object.keys(obj).filter(function (key) {
      return obj[key] === undefined;
    });
    validate(missingKeys, source, 'Missing required fields');
  },
  isNotEmptyArray: function isNotEmptyArray(obj, source) {
    var missingKeys = Object.keys(obj).filter(function (key) {
      return !Array.isArray(obj[key]) || obj[key].length === 0;
    });
    validate(missingKeys, source, 'Fields should be arrays with at least one value');
  },
  isNumeric: function isNumeric(obj, source) {
    var invalidKeys = Object.keys(obj).filter(function (key) {
      return !(!isNaN(parseFloat(obj[key])) && isFinite(obj[key]));
    });
    validate(invalidKeys, source, 'Fields should numbers');
  },
  isOneOf: function isOneOf(actual, allowed, source) {
    if (!allowed.includes(actual)) {
      var message = "".concat(source || '', " Validation check: ").concat(actual, " should be one of \"").concat(allowed.join(','), "\".");
      throw new Error(message);
    }
  }
};
exports.assert = assert;

function validate(missingKeys, source, error) {
  if (missingKeys.length > 0) {
    var message = "".concat(source || '', " Validation check: ").concat(error, ": \"").concat(missingKeys.join(','), "\".");
    throw new Error(message);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/utils/assert.js
// module id = 43
// module chunks = 0